"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFeatureProducedInVariantSuggestionRequest = instanceOfFeatureProducedInVariantSuggestionRequest;
exports.FeatureProducedInVariantSuggestionRequestFromJSON = FeatureProducedInVariantSuggestionRequestFromJSON;
exports.FeatureProducedInVariantSuggestionRequestFromJSONTyped = FeatureProducedInVariantSuggestionRequestFromJSONTyped;
exports.FeatureProducedInVariantSuggestionRequestToJSON = FeatureProducedInVariantSuggestionRequestToJSON;
exports.FeatureProducedInVariantSuggestionRequestToJSONTyped = FeatureProducedInVariantSuggestionRequestToJSONTyped;
/**
 * Check if a given object implements the FeatureProducedInVariantSuggestionRequest interface.
 */
function instanceOfFeatureProducedInVariantSuggestionRequest(value) {
    if (!('feature' in value) || value['feature'] === undefined)
        return false;
    return true;
}
function FeatureProducedInVariantSuggestionRequestFromJSON(json) {
    return FeatureProducedInVariantSuggestionRequestFromJSONTyped(json, false);
}
function FeatureProducedInVariantSuggestionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'feature': json['feature'],
    };
}
function FeatureProducedInVariantSuggestionRequestToJSON(json) {
    return FeatureProducedInVariantSuggestionRequestToJSONTyped(json, false);
}
function FeatureProducedInVariantSuggestionRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'feature': value['feature'],
    };
}
//# sourceMappingURL=featureProducedInVariantSuggestionRequest.js.map